import React, { useMemo, useState } from "react";
import "./weChatCommon.scss";
import "./weChatUsernameComponent.scss";
import {
  getWeChatContext,
  setWeChatLoginEmail,
} from "../../utils/weChatContext.utils";

const LOGIN_ID_URL = "/api-gateway/identity-wechat/identity/wechat/auth/loginId";
const PASSWORD_URL = "/account-center/wechat/wechat-password.html";

function WeChatUsernameComponent() {
  const [emailAdd, setEmailAdd] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const weChatContext = useMemo(() => getWeChatContext(), []);
  const search = window.location.search;
  const UID = weChatContext.UID || "";
  window?.tfIdentityGlobals?.hideLoader();

  const handleCheckEmailAvailability = async () => {
    const trimmedEmail = emailAdd.trim();

    if (trimmedEmail === "") {
      setEmailError("此栏为必填项");
      return;
    }

    if (!UID) {
      setEmailError("Unable to continue. Please restart WeChat sign in.");
      return;
    }

    setEmailError("");
    setIsSubmitting(true);

    try {
      const queryParams = new URLSearchParams({
        loginID: trimmedEmail,
        UID,
        _: Date.now().toString(),
      });
      const response = await fetch(`${LOGIN_ID_URL}?${queryParams}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status !== 200) return;

      const respObj = await response.json();
      const isLoginAvail = respObj.isAvailable;
      const responseData = {
        errorCode: respObj.statusCode,
        errorMessage: "Account Binding Pending",
        UID,
        user: {
          email: trimmedEmail,
        },
      };

      if (typeof window.logAuditData === "function") {
        window.logAuditData(
          "WeChat Login",
          "Account Linking Pending",
          responseData,
          "China"
        );
      }

      if (!isLoginAvail) {
        setWeChatLoginEmail(trimmedEmail);
        window.location.href = `${PASSWORD_URL}${search}`;
      } else {
        setEmailError("此邮箱未注册");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      id="gigya-complete-registration-screen"
      data-caption="Profile Completion"
      data-width="auto"
      className="gigya-screen v2 portrait gigya-composite-control-active we-chat-username-component"
      data-on-pending-verification-screen="gigya-verification-sent-screen"
    >
      <div
        className="gigya-profile-form"
        id="gigya-profile-form we-chat-email-form"
      >
        <div className="gigya-layout-row ui-droppable ui-sortable">
          <div id="we-chat-tabs">
            <div id="we-chat-signIn-tab">
              <button
                type="button"
                className="gigya-composite-control gigya-composite-control-link we-chat-active"
                data-toolbox-item-type="link"
                data-binding="true"
                data-wizard-base-translation-key="LINK_140325667860465580"
              >
                登录
              </button>
              <span className="we-chat-signIn-pointer"></span>
            </div>
            <div id="we-chat-signUp-tab">
              <a
                className="gigya-composite-control gigya-composite-control-link"
                data-toolbox-item-type="link"
                data-binding="true"
                data-wizard-base-translation-key="LINK_33011936696667540"
                href={`/global-registration/registration${search}`}
              >
                注册
              </a>
              <span className="we-chat-signUp-pointer"></span>
            </div>
          </div>
          <label
            className="gigya-label-text gigya-composite-control gigya-composite-control-label main-text"
            data-toolbox-item-type="label"
            data-wizard-base-translation-key="LABEL_82751524717670350"
            data-binding="true"
            data-wizard-text-alignment="left"
          >
            请输入您在 Thermofisher.cn 注册的邮箱
          </label>
          <div
            className="gigya-composite-control gigya-composite-control-textbox we-chat-email-textbox"
            data-toolbox-item-type="textbox"
            data-wizard-base-translation-key="TEXTBOX_136884197726350880"
          >
            <label
              className="gigya-label"
              htmlFor="gigya-textbox-email"
              data-binding="true"
            >
              <span className="gigya-label-text">邮箱</span>
              <label
                className="gigya-required-display"
                data-bound-to="profile.email"
                htmlFor="gigya-textbox-email"
              >
                *
              </label>
            </label>
            <input
              type="text"
              value={emailAdd}
              name="profile.email"
              id="gigya-textbox-email"
              className="gigya-input-text"
              formNoValidate="formnovalidate"
              tabIndex="0"
              data-array-root="profile"
              data-gigya-type="text"
              data-gigya-placeholder="请输入邮箱"
              placeholder="请输入邮箱 *"
              onChange={(event) => {
                setEmailAdd(event.target.value);
                setEmailError("");
              }}
            />
          </div>
        </div>
        <span
          className={`gigya-error-msg${
            emailError ? " gigya-error-msg-active" : ""
          }`}
          data-bound-to="email"
          id="wechat-email-error"
        >
          {emailError}
        </span>
        <div className="gigya-layout-row ui-droppable ui-sortable">
          <div
            className="gigya-composite-control gigya-composite-control-submit"
            data-toolbox-item-type="submit"
            data-wizard-base-translation-key="SUBMIT_31429658457676556"
          >
            <input
              type="button"
              className="gigya-input-submit"
              value="下一步"
              tabIndex="0"
              id="wechat-email-input-submit"
              onClick={handleCheckEmailAvailability}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeChatUsernameComponent;
